import { createSelector } from 'reselect';
import { showIntervalsSelector } from 'selectors/showIntervalsSelector';
import { orderAheadInfoSelector } from 'redux/modules/general';

export const timeIntervalSelector = createSelector(
  [showIntervalsSelector, orderAheadInfoSelector],
  (showIntervals, { timeInterval }) => (showIntervals ? +timeInterval : 15),
);
